import React, { useContext, useEffect, useState } from 'react'
import './Checkout_Room.css'
import Breadcrumb_Comp from '../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
import Payment_Summary from '../profile/right_side_content/inner_details_pages/order_details/payment_summary/Payment_Summary'
import Select_payment from './select-payment/Select_payment'
// import Place_order from './place-order-box/Place_order'
import { getAllOrderAddress, OrderCalculation } from '../../features/order/orderSlice'
import { useDispatch, useSelector } from 'react-redux'
import { Context } from '../../utils/context'
import { IDS } from '../../utils/IDS'
import { faTags } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Pink_Btn from '../common/common_btn/pink_btn/Pink_Btn'
import { useNavigate, useParams } from 'react-router-dom'
import { BookTHEFukingRoom, CalculateTHEFukingRoom, GetAllRooms, GetSingleRoom } from '../../features/admin/room/slice'
import useRazorpay from 'react-razorpay'
import Login_Layout_Modal from '../common/modals/login-signup-modals/Login_Layout_Modal'
import Coupon_canvas from '../common/offcanvas/coupon-offcanvas/Coupon_canvas'
import { getCoupons } from '../../features/admin/common/Slice'
import Successfull_Modal from '../common/modals/common-modal/successfull_modal/Successfull_Modal'
import { myAccount } from '../../features/my_account/Slice'
import { decodeId, encodeId } from '../../utils/common'


const Checkout_Room = ({
    orderAddress,
    setOrderAddress, deliveryNote, setDeliveryNote }) => {
    const { id } = useParams()


    const dispatch = useDispatch();
    const navigate = useNavigate()

    const { signin, bookingData } = useContext(Context);
    const [CouponData, setCouponData] = useState();
    const [paymentData, setPaymentData] = useState({});
    const [modelType, setModelType] = useState("");
    const [selectLogin, setSelectLogin] = useState(false);
    const [couponShow, setCouponShow] = useState(false);
    const [showSuccessfullModal, setShowSuccessfullModal] = useState(false);

    // console.log({ bookingData });


    const room = useSelector((state) => state.stay.room.single_room);
    const [paymentValue, setPaymentValue] = useState(IDS.Payment_Methods.Online);
    const [finalPrice, setFinalPrice] = useState(0);
    const [discountPrice, setDiscountPrice] = useState(0);

    const coupons = useSelector((state) => state.common.addCoupons);

    useEffect(() => {
        if (room?.price) {
            dispatch(getCoupons({ amount: Number(room?.price) }));
        }
    }, [dispatch, id]);

    useEffect(() => {
        dispatch(GetSingleRoom(decodeId(id)));
        setFinalPrice(room?.price);
    }, [dispatch, id]);




    const CalculateTotal = () => {
        if (!room || !bookingData) return;

        const data = {
            check_in_date: bookingData?.check_in_date,
            check_out_date: bookingData?.check_out_date,
            guests_count: bookingData?.guests_count,
            facility_total: bookingData?.facility_total,
            guests_count: bookingData?.guests_count,
            coupon_id: CouponData?.id || null,
        };


        dispatch(CalculateTHEFukingRoom({ id: room?.id, data }))
            .then((res) => {
                if (res.meta.requestStatus === "fulfilled") {
                    const calc = res.payload?.data;

                    setFinalPrice(calc?.total_amount || 0);
                    setDiscountPrice(calc?.discount_price || 0);
                } else {
                    navigate(`/guest-house-details/${encodeId(room?.id)}`)
                }
            });
    };


    // console.log({ finalPrice, CouponData });




    const handlePlaceOrder = (price) => {


        if (!signin) {
            setModelType("select_login");
            setSelectLogin(true);
            return;
        }
        if (!paymentValue) {
            alert("Please select a payment method before placing the order: ");
            return;
        }
        if (paymentValue == IDS.Payment_Methods.Online) {
            handleRazorpay(price)
        } else {
            finalFunction()
        }
    };

    const [razorid, setRazorId] = useState();
    const [Razorpay] = useRazorpay();

    const handleRazorpay = async (price) => {
        const amountInPaise = Math.round(price * 100);
        const options = {
            key: "rzp_test_I05KCFb1v5JJRc",
            amount: amountInPaise,
            currency: "INR",
            name: "Om TApovan",
            description: "Test Transaction",
            image:
                "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

            handler: async (res) => {
                await setRazorId(res.razorpay_payment_id);
                finalFunction(res.razorpay_payment_id);
            },
            prefill: {
                name: "Prajwal Vaychal",
                email: "youremail@example.com",
                contact: "9999999999",
            },
            notes: {
                address: "Razorpay Corporate Office",
            },
            theme: {
                color: "#052c65",
            },
        };

        const rzpay = new Razorpay(options);
        rzpay.open();
    };


    const finalFunction = async (razorpay) => {
        const sendData = new FormData();

        sendData.append("payment_method_id", paymentValue);
        sendData.append("check_in_date", bookingData?.check_in_date);
        sendData.append("check_in_time", bookingData?.check_in_time);
        sendData.append("check_out_date", bookingData?.check_out_date);
        sendData.append("check_out_time", bookingData?.check_out_time);

        sendData.append("discount_price", discountPrice || 0);
        sendData.append("total_amount", finalPrice);


        sendData.append("facility_total", bookingData?.facility_total || 0);
        sendData.append("facilities", JSON.stringify(bookingData?.facilities || []));


        sendData.append("guests_count", bookingData?.guests_count);
        sendData.append("guest_details", JSON.stringify(bookingData?.guest_details || []));
        sendData.append("extra_persons", bookingData?.extra_persons || 0);


        const datafinal = {

            payment_method_id: paymentValue,
            ...bookingData,
            discount_price: discountPrice || 0,
            total_amount: finalPrice || 0,
            guests_count:
                (Number(bookingData?.adults) || 0) +
                (Number(bookingData?.children) || 0) +
                (Number(bookingData?.extra_persons) || 0),
        };

        if (CouponData) {
            datafinal.coupon_id = CouponData?.id
            sendData.append("coupon_id", CouponData?.id);

        }

        if (razorpay) {
            datafinal.transaction_id = razorpay;
            sendData.append("transaction_id", razorpay);
        }

        // console.log("datafinal222222222", datafinal);
        for (let pair of sendData.entries()) {
            console.log(pair[0], pair[1]);
        }


        const res = await dispatch(BookTHEFukingRoom({ id: room?.id, data: sendData }));
        // console.log({ BookTHEFukingRoom: res });

        if (res.meta?.requestStatus === "fulfilled") {
            setShowSuccessfullModal(true);
            setTimeout(() => {
                setShowSuccessfullModal(false);
                navigate(`/guest-house-details/${encodeId(room?.id)}`);
            }, 3000);
        } else if (res.meta?.requestStatus === "rejected") {
            alert(`${res?.payload?.errors?.message || res?.payload?.errors || "Somthing Went Wrong"}`)
        }

        if (res?.payload?.errors?.check_in_date?.location) {
            navigate(`/guest-house-details/${encodeId(room?.id)}`)
        }
    };

    useEffect(() => {
        CalculateTotal();
    }, [room, CouponData, bookingData]);



    const breadcrumbs = [
        { label: "HOme", link: `/home`, active: false },
        { label: "Room BOOKING", link: `/guest-house-details/${encodeId(room?.id)}`, active: false },
        { label: "PAYMENT", link: "", active: true, }
    ];
    const user = useSelector((state) => state.myaccount.addMyaccount);


    useEffect(() => {
        dispatch(myAccount());
    }, [dispatch]);
    return (
        <>
            <section className='Checkout_Room'>
                <div className='container'>
                    <Breadcrumb_Comp data={breadcrumbs} />

                    <div className='row'>
                        <div className='col-lg-8 mb-lg-0 mb-4 p-lg-auto p-0'>

                            <div className='total_payment_div'>
                                <p className='label_text'>{room?.name || "--"}</p>
                                <div className='rupee_text_div'>
                                    <p className='rupee_text'>₹ {finalPrice || "0"}</p>
                                </div>
                            </div>

                            <Select_payment
                                walletAmount={user?.Wallet?.amount}
                                orderAddress={orderAddress}
                                paymentValue={paymentValue}
                                setPaymentValue={setPaymentValue}
                            />

                            <div className='book_btn_holder'>
                                <Pink_Btn
                                    btnText={"Book"}
                                    onClick={() => handlePlaceOrder(finalPrice)}
                                />
                            </div>

                        </div>
                        <div className='col-lg-4 p-lg-auto p-0 '>

                            <div className='payment_summary_div'
                            >
                                <div className="coupon_div">
                                    <div className="special_div">
                                        <img
                                            src="/assets/images/checkout/green_discount.png"
                                            className="discount_img"
                                        />
                                        <p className="special_text">Something Special for you!</p>
                                    </div>
                                    <div className="coupons_div">
                                        <div className="left_side">
                                            <FontAwesomeIcon icon={faTags} className="tag_icon" />
                                            <span className="coupon_text">Coupons</span>
                                        </div>
                                        <div className="btn_holder">
                                            <button
                                                className="black_btn"
                                                onClick={() => setCouponShow(true)}
                                            >
                                                View
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            {/* <Payment_Summary isCheckoutPage data={paymentData?.order_summary} /> */}

                            {/* <Place_order
                                setCouponData={setCouponData}
                                deliveryNote={deliveryNote}
                                paymentData={paymentData}
                                isSignIn={signin}
                                orderAddress={orderAddress}
                                paymentValue={paymentValue}
                            /> */}
                        </div>
                    </div>
                </div>
            </section>

            <Login_Layout_Modal
                modalType={modelType}
                show={selectLogin}
                onHide={() => setSelectLogin(false)}
            />

            <Coupon_canvas
                setCouponData={setCouponData}
                data={paymentData?.order_summary}
                price={finalPrice}
                coupons={coupons?.data?.data ?? []}
                show={couponShow}
                onHide={() => setCouponShow(false)}
            />

            <Successfull_Modal
                show={showSuccessfullModal}
                onHide={() => setShowSuccessfullModal(false)}
                headtext={'Spiritual Stay Booking'}
                successfultext={'Guest House Booked Successfully!'}
                subtext={'See You Soon!'}
                subtext2={'Have a nice time ahead'}
            />
        </>
    )
}

export default Checkout_Room
    // const CalculateTotal = () => {

    //     const start = new Date(bookingData?.check_in_date);
    //     const end = new Date(bookingData?.check_out_date);

    //     const nights = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

    //     const extra_person_total =
    //         bookingData?.extra_persons * room?.extra_person_charge * nights;

    //     const price_per_night = room?.price;

    //     const base_amount = price_per_night * nights;

    //     let total_amount = base_amount + extra_person_total


    //     const originalPrice = total_amount || 0;

    //     const finalPrice =
    //         CouponData?.Discount_Type?.id === 2
    //             ? (originalPrice * (CouponData?.discount || 0)) / 100
    //             : (parseFloat(CouponData?.total_amount || 0));

    //     finalPrice.toFixed(2);

    //     console.log({ finalPrice, total_amount });



    //     if (finalPrice && CouponData) {
    //         total_amount = parseInt(total_amount) - parseInt(finalPrice)
    //     }

    //     setFinalPrice(total_amount || room?.price)

    // }

    // const CalculateTotal = () => {
    //     if (!room || !bookingData) return;




    //     const start = new Date(bookingData?.check_in_date);
    //     const end = new Date(bookingData?.check_out_date);

    //     // Nights count
    //     const nights = Math.max(1, Math.ceil((end - start) / (1000 * 60 * 60 * 24)));

    //     const extra_person_total =
    //         (bookingData?.extra_persons || 0) *
    //         (room?.extra_person_charge || 0) *
    //         nights;

    //     const price_per_night = Number(room?.price || 0);

    //     const base_amount = price_per_night * nights;
    //     const facility_total = bookingData?.facility_total * bookingData?.guests_count;

    //     let total_amount = base_amount + extra_person_total + Number(facility_total);


    //     let discountAmount = 0;

    //     if (CouponData) {
    //         const originalPrice = total_amount;

    //         if (CouponData?.Discount_Type?.id === 2) {

    //             discountAmount = (originalPrice * (CouponData?.discount || 0)) / 100;
    //         } else {

    //             discountAmount = Number(CouponData?.total_amount || 0);
    //         }
    //     }


    //     const finalPrice = Math.max(total_amount - discountAmount, 0);

    //     setFinalPrice(finalPrice);
    //     setDiscountPrice(discountAmount)
    //     console.log({
    //         nights,
    //         base_amount,
    //         extra_person_total,
    //         total_amount_before_discount: total_amount,
    //         discountAmount: discountAmount,
    //         finalPrice
    //     });


    //     const data = {
    //         check_in_date: start,
    //         check_out_date: end,
    //         guests_count: bookingData?.guests_count,
    //         facility_total: facility_total,
    //         coupon_id: CouponData?.id,
    //         discount_price: discountAmount,
    //     }
    //     dispatch(CalculateTHEFukingRoom({ id: room?.id, data: data }))
    // };
